import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'
import { initialState } from '../context'
import { colors } from '../clever-ui-kit/style'

function SEO({ description, lang, meta, title, image, noIndex = false }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            url
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:author`,
          content: site.siteMetadata.author,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `theme-color`,
          content: colors.main,
        },
        {
          property: `og:image`,
          content: image ? image : `/media/ogimage.png`,
        },
        // {
        //   property: `og:image`,
        //   content: `${site.siteMetadata.url}${ogimage}`,
        // },
        {
          name: `twitter:creator`,
          content: site.siteMetadata?.author || ``,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          property: `og:designer`,
          content: 'Adam Drabik <aadamdrabik@gmail.com>',
        },
        {
          name: `author`,
          content: 'Adam Drabik <aadamdrabik@gmail.com>',
        },
        noIndex && { name: `robots`, content: 'noindex,nofollow' },
        noIndex && { name: `googlebot`, content: 'noindex' },
        noIndex && { name: `googlebot-news`, content: 'nosnippet' },
        noIndex && { name: `AdsBot-Google`, content: 'noindex' },
      ].concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: initialState.language || `pl`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
}

export default SEO
